import React, { Component } from 'react';
import { Jumbotron, Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';


export class Home extends Component {
    displayName = Home.name;

    render() {
        var isAuthenticated = this.props.auth.isAuthenticated();

        return (
            <div>
                {
                    isAuthenticated ? (
                        <Redirect to="/applicantList" />
                    ) : (
                        <Jumbotron>
                            <h2>
                                Welcome to Immigration Services Monitor
                                <br />
                                <small>Simplifying Applicant Information</small>
                            </h2>

                            <span>{' '} </span>
                            <Button bsSize="lg" bsStyle="primary"
                                onClick={this.props.auth.login}>
                                Log in / Sign Up
                            </Button>
                        </Jumbotron>
                    )
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js